/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type QrCodeCell_qrCode$ref: FragmentReference;
declare export opaque type QrCodeCell_qrCode$fragmentType: QrCodeCell_qrCode$ref;
export type QrCodeCell_qrCode = {|
  +id: string,
  +createdAt: any,
  +sign: string,
  +$refType: QrCodeCell_qrCode$ref,
|};
export type QrCodeCell_qrCode$data = QrCodeCell_qrCode;
export type QrCodeCell_qrCode$key = {
  +$data?: QrCodeCell_qrCode$data,
  +$fragmentRefs: QrCodeCell_qrCode$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QrCodeCell_qrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sign",
      "storageKey": null
    }
  ],
  "type": "QrCode"
};
// prettier-ignore
(node/*: any*/).hash = '85ce8f546a098579ef47a7123e6679d7';

module.exports = node;
